// src/components/MonthSelector.jsx
import React from 'react';
import Dropdown from './Dropdown';
import { MONTHS } from '../data/constants';

const MonthSelector = ({ selected, setSelected, label }) => (
  <Dropdown label={label} options={MONTHS} value={selected} onChange={setSelected} />
);

export default MonthSelector;
